import React, { type PropsWithChildren, type HTMLAttributes } from 'react';
import cx from 'classnames';
import { mcdsFlagCheck } from '@mc/wink/helpers/utils-ts';
import stylesheet from './ContentArea.css';

export type ContentAreaProps = PropsWithChildren<{
  as?: React.ElementType;
  size?: 'standard' | 'narrow' | 'wide' | 'full' | 'max';
  disabledPadding?: boolean;
}> &
  HTMLAttributes<HTMLElement>;

/**
 * Listbox is a primitive component used to power other design system components.
 * It should *NEVER* be used directly in app code.
 *
 * It's job is to abstract the fluid padding specs that define main content spaces in the app.
 */
const ContentArea = React.forwardRef<HTMLElement, ContentAreaProps>(
  function ContentArea(
    {
      as: Component = 'div',
      children,
      className,
      size = 'standard',
      disabledPadding = false,
      ...rest
    },
    forwardedRef,
  ) {
    const isFocusedStatePageHeaderOn = mcdsFlagCheck(
      'xp_mcds_redesign_focused_state_page_header',
    );

    return (
      <Component
        className={cx(
          stylesheet.root,
          stylesheet[size],
          className,
          disabledPadding && stylesheet.disabledPadding,
        )}
        ref={forwardedRef}
        {...(isFocusedStatePageHeaderOn ? rest : {})}
      >
        {children}
      </Component>
    );
  },
);

export default ContentArea;
